var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detection_request_wrap"},[_c('div',{staticClass:"detection_request_title"},[_vm._v(_vm._s(_vm.$t('request1')))]),_c('detection-write-component',{attrs:{"detection-type":'requestWrite'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }